import React, { useEffect } from "react";
import { Route, Routes, Navigate, useLocation } from "react-router-dom";
import { CommonUtils } from "@pl-flight-recorder/common/utils/common.utils";
import MfaAppsPage from "./pages/MfaAppsPage/MfaAppsPage";
import MfaAppPage from "./pages/MfaAppPage/MfaAppPage";
import PulseAppHeader from "./components/PulseAppHeader/PulseAppHeader";
import { initializeUser } from "./store/actions/initializeUser";
import TokenReceiver from "./components/TokenReceiver/TokenReceiver";
// import AuthenticationPage from "./pages/AuthenticationPage/AuthenticationPage";
import LogoutPage from "./pages/LogoutPage/LogoutPage";
import TokenPage from "./pages/TokenPage/TokenPage";
import MfaAppSettingsPage from "./pages/MfaAppSettingsPage/MfaAppSettingsPage";
import DebugPage from "./pages/DebugPage/DebugPage";
import DesignSystemPage from "./design-system-fe/DesignSystemPage/DesignSystemPage";
import OnboardingMenu from "./components/OnboardingMenu/OnboardingMenu";
import { useSelector } from "react-redux";
import { RootState } from "./store/store";
import SurveyPage from "./pages/SurveyPage/SurveyPage";

const App: React.FC = () => {
  CommonUtils.test();
  const location = useLocation();
  const { showOnboarding } = useSelector(
    (state: RootState) => state.onboarding,
  );

  // Check if current path starts with /survey or /designsystem
  const hideHeader =
    location.pathname.startsWith("/survey") ||
    location.pathname.startsWith("/designsystem");

  useEffect(() => {
    initializeUser();
  }, []);

  return (
    <>
      {!hideHeader && <PulseAppHeader />}
      <Routes>
        <Route path="/" element={<MfaAppsPage />} />
        <Route
          path="/project/:projectId/settings"
          element={<MfaAppSettingsPage />}
        />
        <Route path="/project/:projectId" element={<MfaAppPage />} />
        <Route path="/receive-token" element={<TokenReceiver />} />
        <Route path="/debug" element={<DebugPage />} />
        <Route path="/designsystem" element={<DesignSystemPage />} />
        {/* <Route path="/auth" element={<AuthenticationPage />} /> */}
        <Route path="/logout" element={<LogoutPage />} />
        <Route path="/token/:token" element={<TokenPage />} />
        <Route path="/token/:token/:workspaceId" element={<TokenPage />} />
        <Route path="/survey/:captureId" element={<SurveyPage />} />
        <Route path="/survey/:captureId/:userId" element={<SurveyPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      {showOnboarding && !hideHeader && <OnboardingMenu />}
    </>
  );
};

export default App;
